import { getToken } from './storage';
import camelcaseKeys from 'camelcase-keys';

const DEFAULT_CONFIG = {
  headers: {
    'Content-Type': 'application/json',
  },
};

const checkStatus = async response => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  } else {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
};

const restCall = (method, url, data, config = DEFAULT_CONFIG) => {
  let body;
  let innerConfig = config;

  if (data && typeof data === 'object') {
    body = JSON.stringify(data);
  } else {
    body = data;
  }

  return fetch(url, {
    ...innerConfig,
    method,
    body,
  })
    .then(checkStatus)
    .then(res => res.json())
    .then(res => camelcaseKeys(res, { deep: true }));
};

const authCall = (method, url, data, config = {}) =>
  getToken().then(token =>
    restCall(method, url, data, {
      ...config,
      headers: {
        ...config.headers,
        Authorization: `Bearer ${token}`,
      },
    }),
  );

export { restCall, authCall };
